import React, { useState } from "react";
import Sidebar from "../../common/components/Sidebar/sidebar";
import TimeLine from "../../common/components/TimeLine/TimeLine";
import RightSidebar from "../../common/components/RightSidebar/RightSidebar";
import SblcRollOverCom from "../../common/components/sblcrollovercomponent/SblcRollOverCom";

const SblcRollOver = () => {
  const [isCount, setIsCount] = useState(3);
  return (
    <>
      <div className="container-fluid">
        <div className="row">
          {/* Sidebar */}
          <div className="col-12  col-lg-2 p-0">
            <Sidebar />
          </div>

          {/* Main Content Area */}
          <div className="col-12 col-md-12 col-lg-10">
            {/* Timeline Header */}
            <div className="row align-items-center">
              <div className="col-12 px-3 px-md-1 px-lg-1">
                <div className="headerTimeLine">
                  <TimeLine currentStep={isCount} />
                </div>
              </div>
            </div>

            {/* Main Body Section */}
            <div className="row px-3 px-md-4 px-lg-5 mt-2">
              {/* SBLC Section */}
              <div className="col-12 col-lg-9 d-flex justify-content-center align-items-start mb-4 mb-lg-0">
                <div className="statusWaiverMainContainer w-100">
                  {/* <SblcConfirm /> */}
                  <SblcRollOverCom />
                </div>
              </div>

              {/* Right Sidebar */}
              <div className="col-12 col-lg-3">
                <div className="right_sidebar">
                  <RightSidebar setIsCount={setIsCount} islabel="SBLC ROLL OVER" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default SblcRollOver;
